import React, { useState } from 'react'
import { Typography, Spinner } from '@telavita-core/react-design-kit'

import ReservationService from 'services/reservation'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { CancelReservationSuccess } from './CancelReservationSuccess'
import { CancelReservationForm } from './CancelReservationForm'

import * as S from './styles'

interface CancelRecurrentReservationModalProps {
  open: boolean
  onSetOpen: (open: boolean) => void
  onRefresh: () => void
  isProfessional: boolean
  reservationUUID: string
  reservationHour: string
  reservationWeekday: string
  patientUsername: string
  patientFullName: string
  professionalUsername: string
  professionalFullName: string
}

enum Status {
  IDLE = 'IDLE',
  SUBMITTING = 'SUBMITTING',
  SUCCESS = 'SUCCESS',
}

export const CancelRecurrentReservationModal = ({
  open,
  onSetOpen,
  onRefresh,
  isProfessional,
  reservationUUID,
  reservationHour,
  reservationWeekday,
  patientUsername,
  patientFullName,
  professionalUsername,
  professionalFullName,
}: CancelRecurrentReservationModalProps): JSX.Element => {
  const [reason, setReason] = useState('')
  const [status, setStatus] = useState(Status.IDLE)

  if (!open) return null
  const onSubmit = () => {
    setStatus(Status.SUBMITTING)

    ReservationService.deleteAllReservation({
      uuid: reservationUUID,
      professional_username: professionalUsername,
      patient_username: patientUsername,
      reason: reason,
    })
      .then(() => {
        setStatus(Status.SUCCESS)
        setReason('')
      })
      .catch(() => {
        setStatus(Status.IDLE)
        setReason('')
      })
  }

  const handleClose = () => {
    onSetOpen(false)
    if (status === Status.SUCCESS) {
      onRefresh()
    }
  }

  const getTitle = () => {
    if (status !== Status.IDLE) {
      return null
    }

    return (
      <Typography variant='header4'>
        {isProfessional
          ? 'Cancelar toda a reserva'
          : <>
              Cancelar toda a reserva:
              <br />
              <span style={{ color: '#FD4949' }}>
                {reservationWeekday}, {reservationHour}
              </span>
            </>
        }
      </Typography>
    )
  }
  
  const getSubtitle = () => {
    if (status !== Status.IDLE) {
      return null
    }

    return (
      <Typography
        variant='content2'
        inheritColor
        inlineStyles={{ color: '#898989' }}
        center
      >
        {isProfessional
          ? <>Paciente <b>{patientFullName}</b></>
          : <>com Psicólogo(a) <b>{professionalFullName}</b></>
        }
      </Typography>
    )
  }
  
  return (
    <ModalGeneric 
      modalTitle={getTitle()} 
      modalSubtitle={getSubtitle()} 
      onCloseModal={handleClose}
    >
      
      {status === Status.IDLE &&
        <CancelReservationForm
          isProfessional={isProfessional}
          reservationWeekday={reservationWeekday}
          reservationHour={reservationHour}
          reason={reason}
          onSetReason={setReason}
          onSubmit={onSubmit}
        />
      }

      {status === Status.SUBMITTING && 
        <S.SpinnerWrapper>
          <Spinner />
        </S.SpinnerWrapper>
      }

      {status === Status.SUCCESS &&
        <CancelReservationSuccess
          isProfessional={isProfessional}
          handleClose={handleClose}
        />
      }

    </ModalGeneric>
  )
}